module.exports = __webpack_public_path__ + "img/secondary_11x3.af7ab972.svg";